import MDButton from "components/MDButton";
import AddBoxIcon from "@mui/icons-material/AddBox";
import React, { useEffect, useState } from "react";
import MDModal from "components/MDModal";
import MDInput from "components/MDInput";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Multiselect from "./components/Multiselect";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import { useParams } from "react-router-dom";
const CreateModal = ({ editData, handleRefresh }) => {
  const Service = useAppServices();
  const { location_id, app_id } = useParams()
  const [openAddProduct, setOpenAddProduct] = useState(false);
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setProcessing(true);
      const payload = {
        _id: editData?._id,
        app_name: e.target.app_name.value,
        app_id: e.target.app_id.value,
        client_id: e.target.client_id.value,
        client_secret: e.target.client_secret.value,
        sso: e.target.sso.value,
        form_url: e.target.form_url.value,
        form_url: e.target.form_url.value,
        query_key: e.target.query_key.value,
        forward_url: e.target.forward_url.value,
        main_app_id: app_id,
        location_id: location_id
      };
      const { response } = await Service.snapshot_onboarding.update({ payload });
      if (response) {
        setOpenAddProduct(false);
        setProcessing(false);
        handleRefresh();
      } else {
        setProcessing(false);
      }
    };
    return (
      <MDModal open={open} onClose={onClose}>
        <MDBox>
          <MDTypography component="h1" mb={3} variant="h5">
            App
          </MDTypography>

          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={{ width: 335 }}
          >
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  App Name
                </MDTypography>
                <MDInput
                  defaultValue={editData?.app_name}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="App Name"
                  name="app_name"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  App ID
                </MDTypography>
                <MDInput
                  defaultValue={editData?.app_id}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="App ID"
                  name="app_id"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Client ID
                </MDTypography>
                <MDInput
                  defaultValue={editData?.client_id}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Client ID"
                  name="client_id"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Client Secret
                </MDTypography>
                <MDInput
                  defaultValue={editData?.client_secret}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Client Secret"
                  name="client_secret"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  SSO Key
                </MDTypography>
                <MDInput
                  defaultValue={editData?.sso}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="SSO Key"
                  name="sso"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Location Id Custom Field Key
                </MDTypography>
                <MDInput
                  defaultValue={editData?.query_key}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Location Id Custom Field Key"
                  name="query_key"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Form Url
                </MDTypography>
                <MDInput
                  defaultValue={editData?.form_url}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Form Url"
                  name="form_url"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Forwarding Url
                </MDTypography>
                <MDInput
                  defaultValue={editData?.forward_url}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Forwarding Url"
                  name="forward_url"
                />
              </MDBox>
            </Grid>
            <MDBox>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                disabled={processing}
                loading={processing}
                sx={{ mt: 4, mb: 1 }}
                fullWidth
              >
                Update
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    );
  }
  const closeAddProduct = (subscription) => {
    // if (subscription?._id)
    setOpenAddProduct(false);
  };
  return (
    <>
      <MDButton
        sx={{ marginLeft: '4px' }}
        variant="contained"
        color="info"
        size="small"
        onClick={() => setOpenAddProduct(true)}
      >
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  );
};

export default CreateModal;
